/* eslint-disable no-console */
import React from "react";
import { useSelector } from "react-redux";
import { AdminPageBody } from "../../../layout/AdminPage/AdminPageBody";
import { BookingList as BookingListMole } from "../../molecules";
import { BookingWrapper } from "./Booking.style";
import { BookingListToolbar } from "./BookingListToolbar";

export const BookingList: React.FC = () => {
  const { bookings } = useSelector((state: any) => state.bookings);
  const { loading } = useSelector((state: any) => state.async);
  const [searchBookingId, setSearchBookingId] = React.useState("");
  const filteredBookings = React.useMemo(() => {
    const query = searchBookingId.trim().toLowerCase();
    if (!query) return bookings;
    return bookings.filter((booking: any) =>
      String(booking.bookingId || "")
        .toLowerCase()
        .includes(query)
    );
  }, [bookings, searchBookingId]);
  return (
    <AdminPageBody
      pageToolbar={
        <BookingListToolbar
          searchBookingId={searchBookingId}
          onSearchBookingIdChange={setSearchBookingId}
        />
      }
    >
      <BookingWrapper>
        <BookingListMole bookings={filteredBookings} loading={loading} />
      </BookingWrapper>
    </AdminPageBody>
  );
};
